<div class="tabs_content">
    <div class="filter_div">
        <ul class="d-flex align-items-center" (click)="openMonthPicker(monthInput)">
            <li><img src="../../../../assets/images/calender.png" class="h-30"></li>
            <li class="ml-1">
                <input
                    #monthInput
                    type="month"
                    [min]="minDate"
                    [max]="maxDate"
                    [formControl]="monthControl"
                    [disabled]="disabled"
                    class="dropbtn"
                    />
            </li>
        </ul>
    </div>
</div>